import Vue from 'vue'
import App from './App.vue'
// import LoginPage from './views/Login.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import api from './api' // 引入刚才的 api 封装

Vue.use(ElementUI);
Vue.prototype.$api = api; // 全局挂载

const userManager = Vue.observable({
  account: null,
  permission: 0,
  shopname: '',
  password: '',
  login(account, permission, shopname, password) {
    this.account = account;
    this.permission = permission;
    this.shopname = shopname;
    this.password = password;
    localStorage.setItem('account', account);
    localStorage.setItem('permission', permission);
    localStorage.setItem('shopname', shopname);
    localStorage.setItem('pw', this.encrypt(password));
    // 触发Vue的响应式更新
    this.$emit && this.$emit('userChanged');
  },
  logout() {
    this.account = null;
    this.permission = 0;
    this.shopname = '';
    this.password = '';
    localStorage.removeItem('account');
    localStorage.removeItem('permission');
    localStorage.removeItem('shopname');
    localStorage.removeItem('pw');
    // 触发Vue的响应式更新
    this.$emit && this.$emit('userChanged');
  },
  restore() {
    this.account = localStorage.getItem('account');
    this.permission = Number(localStorage.getItem('permission'));
    this.shopname = localStorage.getItem('shopname');
    this.password = localStorage.getItem('pw');
  },
  isLoggedIn() {
    return !!this.account;
  },
  encrypt(str) {
    return btoa(str);
  },
  decrypt() {
    return atob(this.password);
  }
});

Vue.prototype.$user = userManager;

// 在应用启动时恢复用户登录状态
userManager.restore();

// 登录有效性校验，每次 app 启动自动检查账号是否存在数据库
(async function validateUser() {
  if (userManager.isLoggedIn()) {
    try {
      // 假定后端接口：/user/shop/login?uid=xxx，返回 { code:0, ... }
      const res = await await api.post(`/user/shop/login?uid=${userManager.account}&password=${userManager.decrypt()}`);
      if (!res || res.code != 0) {
        userManager.logout();
        // 可选：全局提示
        Vue.prototype.$message && Vue.prototype.$message.error('当前账号已无效，请重新登录');
        window.location.href = '/login';
        return;
      }
      // 账号有效什么都不做
    } catch (e) {
      // console.log(e);
      // 网络或后端错误也建议退出重新登录
      userManager.logout();
      Vue.prototype.$message && Vue.prototype.$message.error('账号校验失败，请重新登录');
      window.location.href = '/login';
    }
  }
})();

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
